import { Tabs, Tab } from "@heroui/react";
import { Header } from "./components/Header.tsx";
import { WirePanel } from "./panels/Wire.tsx";
import { PrimitivesPanel } from "./panels/Primitives.tsx";
import { ContextPanel } from "./panels/Context.tsx";
import { CodeExecPanel } from "./panels/CodeExec.tsx";
import { SecurityPanel } from "./panels/Security.tsx";
import { GatesPanel } from "./panels/Gates.tsx";
import { WireLog } from "./components/WireLog.tsx";
import { LabProvider } from "./lib/state.tsx";

const TABS = [
  { key: "wire", section: "§3", title: "The wire", node: <WirePanel /> },
  { key: "primitives", section: "§4", title: "Primitives", node: <PrimitivesPanel /> },
  { key: "context", section: "§5", title: "Context cost", node: <ContextPanel /> },
  { key: "codeexec", section: "§6", title: "Code execution", node: <CodeExecPanel /> },
  { key: "security", section: "§8", title: "Attack surface", node: <SecurityPanel /> },
  { key: "gates", section: "§9", title: "Defences", node: <GatesPanel /> },
];

export function App() {
  return (
    <LabProvider>
      <div className="flex h-full flex-col">
        <Header />
        <div className="grid min-h-0 flex-1 grid-cols-1 gap-4 p-4 xl:grid-cols-[minmax(0,1fr)_460px]">
          <main className="min-w-0 overflow-y-auto wire-scroll">
            <Tabs
              aria-label="Deck sections"
              variant="underlined"
              classNames={{
                base: "sticky top-0 z-20 bg-background/85 backdrop-blur",
                tabList: "gap-2 overflow-x-auto",
                tab: "px-3",
              }}
            >
              {TABS.map((t) => (
                <Tab
                  key={t.key}
                  title={
                    <span className="flex items-center gap-2">
                      <span className="font-mono text-xs text-default-500">{t.section}</span>
                      <span>{t.title}</span>
                    </span>
                  }
                >
                  <div className="pt-2 pb-8">{t.node}</div>
                </Tab>
              ))}
            </Tabs>
          </main>

          <aside className="hidden min-h-0 xl:block">
            <WireLog />
          </aside>
        </div>
      </div>
    </LabProvider>
  );
}
